module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold.01bee965.otf";